import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { DxDataGridModule, DxPopoverModule, DxTabsModule, DxTemplateModule, DxBulletModule } from 'devextreme-angular';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatTabsModule} from '@angular/material/tabs';


@NgModule({
  declarations: [TooltipComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    DxDataGridModule,
    DxTemplateModule,
    DxBulletModule,
    DxPopoverModule,
    MatTabsModule,
  ],
  exports: [TooltipComponent],
  bootstrap: [TooltipComponent]
})
export class TooltipModule {
  constructor( library: FaIconLibrary) {
    library.addIcons(faInfoCircle);
  }

// ngDoBootstrap() {
//   const custom = createCustomElement(TooltipComponent, { injector: this.injector });
//   customElements.define('crem-tooltip', custom);
// }

}
